import React from "react";
import {
  StyledBox,
  StyledList,
  StyledTitle,
  TitleContainer,
} from "components/job/index/jobInformationRow";
import { Row, Col } from "antd";
import LabelAndValue from "./labelAndValue";

function JobCover(props) {
  const { data, status } = props;

  return (
    <StyledBox>
      <Row gutter={4}>
        <Col span={24}>
          <StyledList>
            <TitleContainer>
              <StyledTitle>Cover</StyledTitle>
            </TitleContainer>
            <Row gutter={2} style={{ padding: "10px" }}>
              {data?.print_color?.map((printColor, index) => (
                <React.Fragment key={`print-color-${index}`}>
                  <Col xs={12}>
                    <LabelAndValue
                      label="Type"
                      value={printColor.type || "-"}
                      status={status}
                    />
                  </Col>
                  {printColor.selected_color.map(
                    (selectedColor, colorIndex) => (
                      <Col xs={12} key={`print-color-${colorIndex}`}>
                        <LabelAndValue
                          mt2={colorIndex > 0}
                          label={`Color ${colorIndex + 1}`}
                          value={
                            `${
                              selectedColor.type
                            } - ${selectedColor.color.toLowerCase()}` || "-"
                          }
                          status={status}
                        />
                      </Col>
                    )
                  )}
                </React.Fragment>
              ))}
            </Row>
          </StyledList>

          <StyledList $last={!Boolean(data?.hot_stamping)}>
            <TitleContainer>
              <StyledTitle>Paper</StyledTitle>
            </TitleContainer>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col xs={24}>
                <LabelAndValue
                  label="Name"
                  value={
                    `${data?.paper_material?.name} ${data?.paper_grammage}` ||
                    "-"
                  }
                  status={status}
                />
              </Col>
            </Row>
          </StyledList>
          <>
            {data?.hot_stamping && (
              <StyledList $last>
                <TitleContainer>
                  <StyledTitle>Hot Stamping</StyledTitle>
                </TitleContainer>
                <Row gutter={2} style={{ padding: "10px" }}>
                  {data?.hot_stamping?.map((hotStamping, index) => (
                    <Col xs={12} key={`hot-stamping-${index}`}>
                      <LabelAndValue
                        mt2={index > 1}
                        label={`Color ${index + 1}`}
                        value={hotStamping.color || "-"}
                        status={status}
                      />
                    </Col>
                  ))}
                </Row>
              </StyledList>
            )}
          </>
        </Col>
      </Row>
    </StyledBox>
  );
}

export default JobCover;
